window.VegasCart = {
	add: function ($self) {
		let $product = $self.closest('[data-cart=product]');
		let id = $self.data('id') || $product.data('id');
		let cnt = $product.find('input[name=cnt]').val() || 1;
		let weight = $product.find('#tab-kg.active').find('[name=weight]').val() || 0;

		let params = VegasCart.formData({
			id: id,
			cnt: cnt,
			weight: weight
		});

		let $btn = $product.find('.btn-action [data-cart="add"]');
		$btn.attr('data-cart', 'del');
		$btn.text('Убрать из корзины');

		let $productBtn = $product.find('.buttons [data-cart="add"]');
		$productBtn.attr('data-cart', 'del');
		$productBtn.text('Убрать из корзины');

		let $iconCart = $product.find('.icon-cart [data-cart="add"]');
		$iconCart.attr('data-cart', 'del');

		let $btnToggler = $product.find('[data-cart="add"].btn-toggler');
		$btnToggler.attr('title', $btn.data('title-active'));

		$product.addClass('in-cart');

		this.addRequest(params, function (data) {
			if (!data.error) {
				VegasCart.total(data);
				VegasCart.popup($product.data('title'), true);

				$('[data-cart="products-count"]').fadeIn();

				yaCounterReachGoal('add-to-cart');
			}
		});
	},

	addRequest: function (params, callback) {
		$.post('/cart/add_product', params, function (data) {
			if (typeof callback == 'function')
				callback(data);
		});
	},

	changeCnt: function ($self, appendParams = {}) {
		let $product = $self.closest('[data-cart=product]');
		let id = $product.data('id');
		let pivot_id = $product.data('pivot_id');
		let cnt = $product.find('input[name=cnt]').val() || 1;
		let params = VegasCart.formData({
			id: id,
			pivot_id: pivot_id,
			cnt: cnt,
			get_products_totals: true,
			get_cart_total_view: true,
		});

		params = extendsFormParams(params, appendParams || {});

		$.post('/cart/change_product', params, function (data) {
			VegasCart.total(data);
		});
	},

	changeWeight: function ($self, appendParams = {}) {
		let $product = $self.closest('[data-cart=product]');
		let id = $product.data('id');
		let pivot_id = $product.data('pivot_id');
		let weight = $product.find('input[name=weight]').data('gr');
		let params = VegasCart.formData({
			id: id,
			pivot_id: pivot_id,
			weight: weight,
			get_products_totals: true,
			get_cart_total_view: true,
		});

		params = extendsFormParams(params, appendParams || {});

		$.post('/cart/change_product', params, function (data) {
			VegasCart.total(data);
		});
	},

	remove: function ($self) {
		let $product = $self.closest('[data-cart=product]');
		let id = $product.data('id');
		let pivot_id = $product.data('pivot_id');
		let params = VegasCart.formData({
			id: id,
			pivot_id: pivot_id,
			get_cart_costs_discounts_methods: true,
		});

		let $btn = $product.find('.btn-action [data-cart="del"]');
		$btn.attr('data-cart', 'add');
		$btn.text('Добавить в корзину');

		let $productBtn = $product.find('.buttons [data-cart="del"]');
		$productBtn.attr('data-cart', 'add');
		$productBtn.text('Добавить в корзину');

		let $iconCart = $product.find('.icon-cart [data-cart="del"]');
		$iconCart.attr('data-cart', 'add');

		$product.removeClass('in-cart');

		let $cartTable = $('.cart-table');
		let rowsCount = parseInt($cartTable.find('[data-cart=product]:visible').length) - 1;

		this.removeRequest(params, function (data) {
			VegasCart.total(data);

			if ($cartTable.length) {
				$product.fadeOut(function () {
					$(this).remove();
				});
				if (rowsCount === 0) location.reload();
			}
		});
	},

	removeRequest: function (params, callback) {
		$.post('/cart/del_product', params, function (data) {
			if (typeof callback == 'function')
				callback(data);
		});
	},

	total: function (data) {
		if (typeof data.products_count !== 'undefined') {
			$('[data-counter=cart]').attr('data-cnt', data.products_count);
		}

		if (typeof data.cart_sum_formatted !== 'undefined') {
			$('[data-counter=cart-sum]').attr('data-sum', data.cart_sum_formatted);
		}

		if (typeof data.cart_sum_formatted !== 'undefined') {
			$('[data-cart=cart-total]').text(data.cart_sum_formatted);
		}

		if (typeof data.discount_cart_sum_formatted !== 'undefined') {
			$('[data-cart=cart-discount-sum]').text('-' + data.discount_cart_sum_formatted);
		}

		if (typeof data.cart_total_view !== 'undefined') {
			let $container = $('.vg-shop-cart__basket.totals');
			$container.after(data.cart_total_view);
			$container.remove();
		}

		this.totalProducts(data);
		this.totalCartProductView(data);
		this.totalDiscountMethods(data);
	},

	totalProducts: function (data) {
		if (typeof data.products_totals !== 'undefined') {
			for (let i in data.products_totals) {
				let item = data.products_totals[i];
				$('.cart-table .cart-prd[data-pivot_id="' + item.pivot_id + '"] .price-total').text(item.price_total_formatted);
			}
		}
	},

	totalCartProductView(data) {
		if (typeof data.product_cart_view !== 'undefined') {
			for (let i in data.product_cart_view) {
				let item = data.product_cart_view[i];

				$cartItem = $('.cart-product[data-pivot_id="' + item.pivot_id + '"]');
				$cartItem.after(item.view);
				$cartItem.remove();
			}
		}
	},

	totalDiscountMethods: function (data) {
		if (typeof data.discounts_methods !== 'undefined') {
			for (let method in data.discounts_methods) {
				$('[data-cart=cart-method-cost][data-method="' + method + '"]').text(
					output_roubles(data.discounts_methods[method].cost)
				);
				$('[data-cart=cart-method-discount][data-method="' + method + '"]').text(
					output_roubles(data.discounts_methods[method].discount)
				);
			}
		}
	},

	updateTotalAll: function (appendParams = {}) {
		let params = extendsFormParams(
			VegasCart.formData($("#form-cart").serializeArray()),
			appendParams || {},
		);

		$.get('/cart/get_totals', params, function (data) {
			VegasCart.total(data);
		});
	},

	formData: function (appendParams) {
		let resultParams = extendsFormParams([{
			name: '_token', value: App.csrf
		}], appendParams || {});

		return resultParams;
	},

	popup: function (title, status = false) {
		let $modal = $('#modal-add-success');

		$modal.find('h4').text('Товар "' + title + '" добавлен в корзину');
		$modal.modal('show');

		setTimeout(() => {
			$modal.modal('hide')
		}, 1500);
	},

	updateToOrderBtn: function () {
		let hasChecked = $('.cart-table .cart-product-checker:checked').length;
		if (hasChecked) {
			$('.btn-to-order').show();
		} else {
			$('.btn-to-order').hide();
		}
	},
};

/**
 * Прослушиватели событий корзины
 **/
let $window = $(window),
	$body = $('body'),
	$document = $(document)
;

$document.on('click', '[data-cart=add]', function () {
	VegasCart.add($(this), 1);
	return false;
});

$document.on('click', '[data-cart=del]', function () {
	VegasCart.remove($(this), 1);
	return false;
});

$document.on('click', '[data-cart=count-items]', function () {
	let $self = $(this),
		sign = $self.data('sign'),
		$container = $self.closest('.vg-widget-count-items'),
		$input = $container.find('input[name=cnt]'),
		cnt = parseInt($input.val() || 1);

	if (sign === 'minus') {
		if (cnt > 1) {
			cnt--;
		}
	} else {
		let max = parseInt($input.attr('max'));
		if (cnt + 1 <= max) cnt++;
	}

	$input.val(cnt);

	if ($(this).data('update-cart')) {
		VegasCart.changeCnt($self, extendsFormParams(
			$("#form-cart").serializeArray(),
			{
				get_cart_costs_discounts_methods: 1
			}
		));
	}

	return false;
});

$document.on('click', '.cart-prd [data-cart=weight-items]', function () {
	let $self = $(this),
		sign = $self.data('sign'),
		$container = $self.closest('.vg-widget-count-items'),
		$input = $container.find('input[name=weight]'),
		step = parseFloat($input.attr('step')),
		w = parseFloat($input.val() || 0.5);

	if (sign === 'minus') {
		if (w >= step * 2) {
			w -= step;
		}
	} else {
		let max = parseInt($input.attr('max'));
		if (max) {
			if (w + step <= max)
				w += step;
		} else {
			w += step;
		}
	}

	$input.val(w).data('gr', w * 1000);

	if ($(this).data('update-cart')) {
		VegasCart.changeWeight($self, extendsFormParams(
			$("#form-cart").serializeArray(),
			{
				get_cart_costs_discounts_methods: 1
			}
		));
	}

	return false;
});

$document.on('change', '.cart-table .cart-product-checker', function () {
	VegasCart.updateToOrderBtn();
	VegasCart.updateTotalAll({get_cart_costs_discounts_methods: 1});
});

$document.on('change', '.vg-shop-cart__discount-methods [name=discount_method]', function () {
	let formParams = $("#form-cart").serialize();
	location.href = location.protocol + '//' + location.host + location.pathname + '/?' + formParams;
});

VegasCart.updateToOrderBtn();

$document.on('submit', '.vg-modal-activate-promocode #form-promocode', function () {
	let $modal = $(this).closest('.vg-modal-activate-promocode');
	let $form = $(this);

	let route = $form.attr('action');
	let params = $form.serializeArray();

	$.post(route, params, function (data) {
		$form.find('.msg').hide();

		if (data.error) {
			$form.find('.msg.msg-error').html(data.msg).show();
		} else {
			$form.find('.msg.msg-success').html(data.msg).show();
			$form.find('button[type=submit]').hide();
			$form.find('.btn-set-promocode').show();
		}
	});

	return false;
});

$document.on('click', '.vg-modal-activate-promocode .btn-set-promocode', function () {
	let $modal = $(this).closest('.vg-modal-activate-promocode');

	let promocode = $modal.find('.input-promocode').val();
	let discount_method = 'promocode';

	let $shopCart = $(".vg-shop-cart");
	$shopCart.find('input[name=promocode]').val(promocode);

	let $dMethod = $shopCart.find('input[name=discount_method][value="' + discount_method + '"]')
		.removeAttr('disabled')
		.prop('checked', true)
		.trigger('change')
	;
});

$('[data-toggle="cart-dropdown"]').click(function () {
	let $_self = $(this),
		$dropdown = $_self.closest('.cart-dropdown'),
		$cart = $('#vg-shop-cart__preview');

	$cart.find('.vg-shop-cart__preview-preload').show();

	if ($dropdown.hasClass('show')) {
		$dropdown.removeClass('show');
	} else {
		$dropdown.addClass('show');

		$.get($_self.data('route'), {}, function (data) {
			if (data.view) {
				$cart.find('.vg-shop-cart__preview-preload').fadeOut('slow');

				$cart.html(data.view);
			}
		});
	}

	return false;
});